import React, { useEffect, useState } from "react";

/**
 * Circular 40×40 profile thumbnail: image, or letter fallback, or load error fallback.
 * Shared by User Profiles and Top Users tables.
 */
export default function ProfilePhotoCell({ imageUrl, displayName }) {
  const [failed, setFailed] = useState(false);
  const src = imageUrl != null && String(imageUrl).trim() !== "" ? String(imageUrl).trim() : "";
  const initial = (displayName || "?").trim().charAt(0).toUpperCase() || "?";

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return (
      <div
        className="h-10 w-10 shrink-0 rounded-full bg-gray-200 flex items-center justify-center text-xs font-semibold text-gray-500 border border-gray-200"
        title={src && failed ? "Image failed to load" : "No photo"}>
        {initial}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt=""
      className="h-10 w-10 shrink-0 rounded-full object-cover border border-gray-200 bg-gray-50"
      onError={() => setFailed(true)}
    />
  );
}
